import { render, staticRenderFns } from "./commonUrlTextarea.vue?vue&type=template&id=2854f03c"
import script from "./commonUrlTextarea.vue?vue&type=script&lang=js"
export * from "./commonUrlTextarea.vue?vue&type=script&lang=js"
import style0 from "./commonUrlTextarea.vue?vue&type=style&index=0&id=2854f03c&prod&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports